import { useTranslation } from "react-i18next";
import { getCurrentLanguage } from "../helpers/Utils";

const reportedKeys = new Set();

async function reportMissing(key, context) {
    if (reportedKeys.has(key)) return;
    reportedKeys.add(key);

    try {
        await fetch(`${process.env.REACT_APP_BASE_URL}locales/add/en/translation`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ [key]: context }),
        });
    } catch (err) {
        console.error("Failed to report missing key", err);
    }
}

export default function useTranslator() {
    const { t, i18n } = useTranslation();
    const _t = (key, context = "", params = {}) => {
        // Check if params is actually the namespace (backward compatibility)
        const namespace = typeof params === "string" ? params : "translation";
        const replacements = typeof params === "object" ? params : {};
        
        const translation = t(key, { ns: namespace });
        const fallback = t(key, { ns: "missing" });

        if (getCurrentLanguage() == "en") {
            // const isMissing = translation === key && fallback === key && namespace === "translation";
            const existsInMain = !!i18n.getResource("en", namespace, key);
            const existsInMissing = !!i18n.getResource("en", "missing", key);
            const isMissing = !existsInMain && !existsInMissing;
            const isChanged = (translation !== key && context && translation !== context || fallback !== key && fallback !== context);
            if ((isMissing || isChanged) && context) {
                reportMissing(key, context || key);
            }
        }

        let result = translation !== key ? translation : fallback !== key ? fallback : context || key;
        
        // Replace dynamic placeholders like :kg with actual values
        if (Object.keys(replacements).length > 0) {
            Object.keys(replacements).forEach(placeholder => {
                result = result.replace(`:${placeholder}`, replacements[placeholder]);
            });
        }
        
        return result;
    };
    return {
        _t,
    };
}
